import { render, staticRenderFns } from "./DatosEducativos.vue?vue&type=template&id=3abf617d&"
import script from "./DatosEducativos.vue?vue&type=script&lang=js&"
export * from "./DatosEducativos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports